import { DepositoService } from "../../services/deposito/depositoService";
import { CalcularImpostoRequest } from "../../types/deposito/calcularImpostoRequest";

import { DepositoCreditoRequest } from "../../types/deposito/depositoCreditoRequest";
import { DepositoDebitoRequest } from "../../types/deposito/depositoDebitoRequest";
import { DepositoPixRequest } from "../../types/deposito/depostioPixRequest";
import { DepositoComponentProps } from "../../views/Deposito";

export interface DepositoContainerProps { }

export default class DepositoContainer {
  public props: DepositoComponentProps

  constructor(props: DepositoComponentProps) {
    this.props = props
  }

  async AbrirBoleto(url: string) {
    const _DepositoService = new DepositoService();

    _DepositoService.AbrirBoleto(url)
  }

  async DepositoPix(request: DepositoPixRequest, callback: () => void) {
    this.props.DepositoPix(request, callback)
  }

  // async DepositoBoleto(request: DepositoBoletoRequest, callback: () => void) {
  //   this.props.DepositoBoleto(request, callback)
  // }

  async DepositoDebito(request: DepositoDebitoRequest, callback: () => void) {
    this.props.DepositoDebito(request, callback)
  }

  async DepositoCredito(request: DepositoCreditoRequest, callback: () => void) {
    this.props.DepositoCredito(request, callback)
  }

  async CalcularImposto(request: CalcularImpostoRequest, carteiraId: number) {
    this.props.CalcularImposto(request, carteiraId)
  }

  async GetMeioPagamento(carteiraId: number) {
    this.props.GetMeioPagamento(carteiraId);
  }

  async GetBoletos(carteiraId: number) {
    this.props.GetBoletos(carteiraId);
  }

}
